import type { EnergyRevenuesListItem } from "../../../RevenueMonitoring.types";

export function calculateRevenueCtPerKwh(
  row: EnergyRevenuesListItem
): number | null {
  const total_revenue_eur =
    (row.vermarktung_net_revenue ?? 0) +
    (row.market_premium_revenue ?? 0) +
    (row.revenue_redispatch ?? 0) +
    (row.revenue_foerderung_redispatch ?? 0) +
    (row.revenue_dva ?? 0);

  const total_kwh =
    (row.vermarktung_volume ?? 0) +
    (row.ausfallarbeit_dva ?? 0) +
    (row.ausfallarbeit_redispatch ?? 0);

  if (total_kwh === 0) return null;
  const total_revenue_ct = total_revenue_eur * 100;
  return total_revenue_ct / total_kwh;
}
